import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative py-16 md:py-20 lg:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-16 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            Kategorie produktów
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            Przeglądaj kategorie USFans Spreadsheet
          </h2>
          <p className="text-foreground-500 mt-3 max-w-xl mx-auto text-sm md:text-base">
            Znajdź dokładnie to, czego szukasz — od odzieży po akcesoria. Każda kategoria prowadzi bezpośrednio do produktów na naszej głównej stronie.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4" data-product-shop>
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-2xl bg-background-50 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.namePl}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4 text-center">
                <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors duration-300">
                  {cat.namePl}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Zobacz wszystkie produkty
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}